import {FETCH_BAR_CATEGORY, FETCH_REPORT_BALANCE,FETCH_AVAIALABLE_COUPONS} from 'constants/ActionTypes'

const INIT_STATE = {barCategory: [], balanceReport: [], result:[], success:''}

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case FETCH_BAR_CATEGORY:
      if (action.payload == undefined) {
        return state
      } else {
        const barCategory = action.payload.map(value => {
          return value
        })
        return {...state, barCategory}
      }
    case FETCH_REPORT_BALANCE:
      if (action.payload == undefined) {
        return state
      } else {
        const balanceReport = action.payload.map(value => {
          return value
        })
        return {...state, balanceReport}
      }
      
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/appRedux/reducers/Reports.js